"use client";
import React from "react";
import { LanguageProvider } from "@/context/language-context";
import { PreferenceProvider } from "@/context/preference-context";

export default function PreferenceProviders({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <PreferenceProvider>
            <LanguageProvider>{children}</LanguageProvider>
        </PreferenceProvider>
    );
}
